<ng-container *ngIf="composerChanges?.length">
  <ng-container *ngFor="let composerItem of composerChanges; let i = index">
    <div class="composer-change-title"
         *ngIf="i === 0 || i > 0 && composerChanges[i - 1] && composerChanges[i - 1]?.Operation !== composerItem?.Operation">
      <img src="/assets/icons/composer-history-pen.svg" alt=""
           *ngIf="history.ActionName === 'COMPOSER_MANUAL' && composerItem?.Operation !== 'M'">
      <img src="/assets/icons/composer-history-link.svg" alt=""
           *ngIf="history.ActionName === 'COMPOSER_IMPORT' && composerItem?.Operation !== 'M'">
      <img src="/assets/icons/composer-history-left-right-arrow.svg" alt=""
           *ngIf="history.ActionName === 'COMPOSER_IMPORT' && composerItem?.Operation === 'M'">
      <img src="/assets/icons/composer-history-left-right-arrow.svg" alt=""
           *ngIf="history.ActionName === 'COMPOSER_MANUAL' && composerItem?.Operation === 'M'">
      <ng-container [ngSwitch]="composerItem?.Operation">
        <ng-container>
          <ng-container *ngSwitchCase="'C'">

            <ng-container *ngIf="!composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <ng-container *ngIf="composerItem.IsMain">
                  <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_OFFER_ADDED"></span>:
                </ng-container>
                <ng-container *ngIf="!composerItem.IsMain">
                  <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_ADDED"></span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <ng-container *ngIf="composerItem.IsMain">
                  <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_LINKS"></span>
                </ng-container>
                <ng-container *ngIf="!composerItem.IsMain">
                  <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_LINKS"></span>
                </ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_ADDED"></span>:
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_LINKS"></span>
              </ng-container>
            </ng-container>

          </ng-container>

          <ng-container *ngSwitchCase="'U'">

            <ng-container *ngIf="!composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_OFFER_CHANGED"></span>:
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_CHANGED"></span>:
              </ng-container>
            </ng-container>

            <ng-container *ngIf="composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_CHANGED"></span>:
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_ORDER_CHANGED"></span>:
              </ng-container>
            </ng-container>

          </ng-container>

          <ng-container *ngSwitchCase="'D'">

            <ng-container *ngIf="!composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_OFFER_DELETED"></span>:
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_DELETED"></span>:
              </ng-container>
            </ng-container>

            <ng-container *ngIf="composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_DELETED"></span>:
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_ORDER_DELETED"></span>:
              </ng-container>
            </ng-container>

          </ng-container>

          <ng-container *ngSwitchCase="'M'">

            <ng-container *ngIf="!composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_MAIN_OFFER_SWITCH"></span>
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_BECOMES_OFFER"></span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="composerItem.IsOrder">
              <ng-container *ngIf="history.ActionName === 'COMPOSER_MANUAL'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_DELETED"></span>:
              </ng-container>
              <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_MANUAL_ORDER_CHANGED"></span>:
              </ng-container>
            </ng-container>

          </ng-container>

        </ng-container>
      </ng-container>
      <span class="sub-title" [ngSwitch]="composerItem?.Operation">
          <ng-container>

            <ng-container *ngSwitchCase="'C'">
              <ng-container *ngIf="!composerItem.IsOrder">
                <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                  <ng-container *ngIf="composerItem.IsMain">
                      <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_OFFER_CREATED"></span>:
                  </ng-container>
                  <ng-container *ngIf="!composerItem.IsMain">
                      <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_ALTERNATIVE_ADDED"></span>
                  </ng-container>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="composerItem.IsOrder">
                <ng-container *ngIf="history.ActionName === 'COMPOSER_IMPORT'">
                  <span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPOSER_ORDER_CREATED"></span>:
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </span>
    </div>

    <div>
      <span class="number">{{ composerItem?.Name }}</span>
      <span *ngIf="composerItem?.IsMain && composerItem?.Operation === 'M'"
            fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_MAIN_OFFER_SWITCH_OFFER"></span>
      <span *ngIf="!composerItem?.IsMain && composerItem?.Operation === 'M'"
            fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_MAIN_OFFER_SWITCH_ALTERNATIVE"></span>
      <span
        *ngIf="composerItem?.Operation !== 'M'"> {{ composerItem?.Amount | appCurrency : composerItem?.CurrencyCode }}</span>
    </div>

  </ng-container>

</ng-container>
